export const defaultUserShape = {
  id: '',
  email: '',
  name: '',
  displayName: '',
  phoneNumber: '',
  baseOperacion: '',
  aboutMe: '',
  avatarUrl: '',
  heroUrl: '',
  companyId: '',
  companyName: '',
  role: '',
  username: '',
  referralCode: '',
  credits: 0,
};

export const mapApiUserToClient = (user = {}) => {
  if (!user || typeof user !== 'object') {
    return { ...defaultUserShape };
  }

  const displayName =
    user.display_name ||
    user.displayName ||
    user.name ||
    user.email ||
    '';

  const normalizeNumber = value => {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : 0;
  };

  return {
    ...defaultUserShape,
    id: user.id || '',
    email: user.email || '',
    name: displayName,
    displayName,
    phoneNumber: user.phone_number || user.phoneNumber || '',
    baseOperacion: user.base_operacion || user.baseOperacion || '',
    aboutMe: user.about_me || user.aboutMe || '',
    avatarUrl: user.avatar_url || user.avatarUrl || '',
    heroUrl: user.profile_hero_url || user.profileHeroUrl || user.hero_url || '',
    companyId: user.company_id || user.companyId || '',
    companyName: user.company_name || user.companyName || '',
    role: user.role || '',
    username: user.username || '',
    referralCode: user.referral_code || user.referralCode || '',
    credits: normalizeNumber(user.credits),
    company: user.company || null,
  };
};
